import { render, staticRenderFns } from "./CreditPublicRecords.vue?vue&type=template&id=2ffc9760&scoped=true&"
import script from "./CreditPublicRecords.vue?vue&type=script&lang=js&"
export * from "./CreditPublicRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffc9760",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ffc9760')) {
      api.createRecord('2ffc9760', component.options)
    } else {
      api.reload('2ffc9760', component.options)
    }
    module.hot.accept("./CreditPublicRecords.vue?vue&type=template&id=2ffc9760&scoped=true&", function () {
      api.rerender('2ffc9760', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/Credit/CreditPublicRecords.vue"
export default component.exports